export class OvertimeLookup {
    id: number;
    lookupCode: string;
    lookupValue: string;
    description: string;
    workflowRuleKey: string;
    overtimeTimeType: string;
    allowedMaxTime: string;
    requiredFileOnOpen: string;
    requiredFileOnClose: string;
    additionalOvertimeDay: number;
    attribute2: string;
    attribute5: string;
    attribute6: string;
    attribute7: string;
    attribute8: string;
    attribute9: string;
    attribute10: string;
    parentLookup: OvertimeLookup;
}
